import { styled } from '../../Styles/stitches.config'

export const Indicator = styled('div', {
    bottom: 0,
    h: 2,
    position: 'absolute',
    transition: '$fast',
    zIndex: 1,
})

export const Tab = styled('div', {
    fontWeight: 600,
    px: '$1',
    textAlign: 'center',
    transition: '$default',
    whiteSpace: 'nowrap',

    variants: {
        active: {
            true: {},
        },
        disabled: {
            true: {
                color: '$neutral300',
                cursor: 'default',
                pointerEvents: 'none',
            },
        },
        variant: {
            default: {
                bgc: '$white',
            },
            primary: {
                bgc: '$primary600',
            },
        },
    },

    compoundVariants: [
        {
            active: 'true',
            variant: 'default',
            css: {
                color: '$primary600',
            },
        },
        {
            active: 'true',
            variant: 'primary',
            css: {
                color: '$white',
            },
        },
        {
            active: 'false',
            variant: 'default',
            css: {
                color: '$primary400',
            },
        },
        {
            active: 'false',
            variant: 'primary',
            css: {
                color: '$neutral300',
            },
        },
    ],
})

export const StyledTabs = styled('div', {
    display: 'grid',
    gridAutoFlow: 'column',
    justifyContent: 'start',
    overflow: 'auto',
    pb: 1,
    position: 'relative',
    scrollbarWidth: 'none',
    userSelect: 'none',

    '@mobile': {
        gap: '$2',
    },

    '@desktop': {
        gap: '$3',
    },

    '&::-webkit-scrollbar': {
        display: 'none',
    },

    variants: {
        variant: {
            default: {
                bgc: '$white',
                borderBottom: '1px solid $neutral300',

                [`& ${Indicator}`]: {
                    bgc: '$primary600',
                },
            },
            primary: {
                bgc: '$primary600',
                borderBottom: '1px solid $primary600',
                [`& ${Indicator}`]: {
                    bgc: '$white',
                },
            },
        },
    },
})
